import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import EducationCertifications from '@/pages/credentials/components/EducationCertifications';
import WorkingExperience from './components/WorkingExperience';

export default function CredentialsPage() {
  return (
    <div className="bg-warm-white font-inter">
      <Navbar />
      <main className="pt-[72px]">
        <EducationCertifications />
        <WorkingExperience />
      </main>
      <Footer />
    </div>
  );
}
